import JSZip from 'jszip/dist/jszip';
export default function createZip() {
  return new JSZip();
}